/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Pit3_TInputs */

const en_viewer_pit3_t = /** @type {(inputs: Viewer_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large integers are already rounded by the time you see them`)
};

const ko_viewer_pit3_t = /** @type {(inputs: Viewer_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`큰 정수는 보는 시점에 이미 반올림되어 있습니다`)
};

const ja_viewer_pit3_t = /** @type {(inputs: Viewer_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きな整数は見る時点ですでに丸められています`)
};

/**
* | output |
* | --- |
* | "Large integers are already rounded by the time you see them" |
*
* @param {Viewer_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_pit3_t = /** @type {((inputs?: Viewer_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_pit3_t(inputs)
	if (locale === "ko") return ko_viewer_pit3_t(inputs)
	return ja_viewer_pit3_t(inputs)
});